// extracted by mini-css-extract-plugin
export default {"wrapper":"consentDetails_wrapper","title":"consentDetails_title"};